export const AG_GRID_LOCALE_IT = {
    // Set Filter
    selectAll: '(Seleziona tutti)',
    selectAllSearchResults: '(Seleziona Tutti i risultati di ricerca)',
    searchOoo: 'Cerca...',
    blanks: '(Vuoto)',
    noMatches: 'Nessuna corrispondenza',

    // Number Filter & Text Filter
    filterOoo: 'Filtro...',
    equals: 'Uguale',
    notEqual: 'Diverso',
    blank: 'Vuoto',
    notBlank: 'Non vuoto',
    empty: 'Scegline uno',

    // Number Filter
    lessThan: 'Minore di',
    greaterThan: 'Maggiore di ',
    lessThanOrEqual: 'Minore o uguale a',
    greaterThanOrEqual: 'Maggiore o uguale a',
    inRange: 'Nell\'intervallo',
    inRangeStart: 'da',
    inRangeEnd: 'a',

    // Text Filter
    contains: 'Contiene',
    notContains: 'Non contiene',
    startsWith: 'Inizia con',
    endsWith: 'Finisce con',

    // Date Filter
    dateFormatOoo: 'dd-mm-yyyy',

    // Filter Conditions
    andCondition: 'AND',
    orCondition: 'OR',

    // Filter Buttons
    applyFilter: 'Applica',
    resetFilter: 'Reset',
    clearFilter: 'Ripulisci',
    cancelFilter: 'Elimina',

    // Filter Titles
    textFilter: 'Filtro testuale',
    numberFilter: 'Filtro numerico',
    dateFilter: 'Filtro per data',
    setFilter: 'Imposta filtro',

    // Side Bar
    columns: 'Colonne',
    filters: 'Filtri',

    // columns tool panel
    pivotMode: 'Modalità Pivot',
    groups: 'Gruppi di righe',
    rowGroupColumnsEmptyMessage: 'Trascina qui per impostare il gruppo di righe',
    values: 'Valori',
    valueColumnsEmptyMessage: 'Trascina qui per aggregare',
    pivots: 'Etichette colonne',
    pivotColumnsEmptyMessage: 'Trascina qui per impostare l\'etichetta della colonna',

    // Header of the Default Group Column
    group: 'Gruppo',

    // Row Drag
    rowDragRows: 'righe',

    // Other
    loadingOoo: 'Caricamento...',
    noRowsToShow: 'Nessun record da mostrare',
    enabled: 'Abilitato',

    // Menu
    pinColumn: 'Blocca colonna',
    pinLeft: 'Blocca a sinistra',
    pinRight: 'Blocca a destra',
    noPin: 'Non bloccato',
    valueAggregation: 'Aggregazione di valore',
    autosizeThiscolumn: 'Auto dimensiona questa colonna',
    autosizeAllColumns: 'Auto dimensiona tutte le colonne',
    groupBy: 'Raggruppa per',
    ungroupBy: 'Disaggruppa per',
    addToValues: 'Aggiungi ${variable} ai valori',
    removeFromValues: 'Rimuovi ${variable} dai valori',
    addToLabels: 'Aggiungi ${variable} alle etichette',
    removeFromLabels: 'Rimuovi ${variable} dalle etichette',
    resetColumns: 'Reimposta colonne',
    expandAll: 'Espandi tutto',
    collapseAll: 'Chiudi tutto',
    copy: 'Copia',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copia con intestazioni',
    copyWithGroupHeaders: 'Copia con il gruppo delle intestazioni',
    paste: 'Incolla',
    ctrlV: 'Ctrl+V',
    export: 'Esporta',
    csvExport: 'Esportazione CSV',
    excelExport: 'Esportazione Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Somma',
    min: 'Min',
    max: 'Max',
    none: 'Nessuno',
    count: 'Conta',
    avg: 'Media',
    filteredRows: 'Filtrato',
    selectedRows: 'Selezionato',
    totalRows: 'Righe totali',
    totalAndFilteredRows: 'Righe',
    more: 'Di più',
    to: 'a',
    of: 'di',
    page: 'Pagina',
    nextPage: 'Pagina successiva',
    lastPage: 'Ultima pagina',
    firstPage: 'Prima pagina',
    previousPage: 'Pagina precedente',

    // Pivoting
    pivotColumnGroupTotals: 'Totale',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Grafico Pivot e modalità Pivot',
    pivotChart: 'Grafico Pivot',
    chartRange: 'Intervallo di grafico',

    columnChart: 'Colonna',
    groupedColumn: 'Raggruppata',
    stackedColumn: 'Bloccata',
    normalizedColumn: '100% Bloccata',

    barChart: 'Barra',
    groupedBar: 'Raggruppata',
    stackedBar: 'Bloccata',
    normalizedBar: '100% Bloccata',

    pieChart: 'A torta',
    pie: 'A torta',
    doughnut: 'A ciambella',

    line: 'Linea',

    xyChart: 'X Y (Dispersione)',
    scatter: 'Dispersione',
    bubble: 'Bolle',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Bloccata',
    normalizedArea: '100% Bloccata',

    histogramChart: 'Istogramma',

    combinationChart: 'Combinazione',
    columnLineCombo: 'Colonne e righe',
    AreaColumnCombo: 'Area e colonne',

    // Charts
    pivotChartTitle: 'Grafico Pivot',
    rangeChartTitle: 'Intervallo del grafico',
    settings: 'Impostazioni',
    data: 'Data',
    format: 'Formato',
    categories: 'Categoria',
    defaultCategory: '(Nessuna)',
    series: 'Serie',
    xyValues: 'X Y Valori',
    paired: 'Modalità comparazione',
    axis: 'Asse',
    navigator: 'Navigazione',
    color: 'Colore',
    thickness: 'Spessore',
    xType: 'Tipo X',
    automatic: 'Automatico',
    category: 'Categoria',
    number: 'Numero',
    time: 'Tempo',
    autoRotate: 'Auto rotazione',
    xRotation: 'Rotazione su X',
    yRotation: 'Rotazione su Y',
    ticks: 'Gradazione',
    width: 'Larghezza',
    height: 'Altezza',
    length: 'Lunghezza',
    padding: 'Padding',
    spacing: 'Spaziatura',
    chart: 'Grafico',
    title: 'Titolo',
    titlePlaceholder: 'Titolo del grafico - doppio click per modificare',
    background: 'Sfondo',
    font: 'Font',
    top: 'Sopra',
    right: 'Destra',
    bottom: 'Sotto',
    left: 'Sinistra',
    labels: 'Etichette',
    size: 'Dimensione',
    minSize: 'Dimensione minima',
    maxSize: 'Dimensione massima',
    legend: 'Leggenda',
    position: 'Posizione',
    markerSize: 'Dimensione pennarello',
    markerStroke: 'Tratto pennarello',
    markerPadding: 'Padding pennarello',
    itemSpacing: 'Spaziatura oggetto',
    itemPaddingX: 'Spaziatura X oggetto',
    itemPaddingY: 'Spaziatura Y oggetto',
    layoutHorizontalSpacing: 'Spaziatura orizzontale',
    layoutVerticalSpacing: 'Spaziatura verticale',
    strokeWidth: 'Larghezza tratto',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Larghezza linea',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefinito',
    fillOpacity: 'Opacità riempimento',
    strokeOpacity: 'Opacità linea',
    histogramBinCount: 'Bin count',
    columnGroup: 'Colonne',
    barGroup: 'Barra',
    pieGroup: 'A torta',
    lineGroup: 'Linea',
    scatterGroup: 'X Y (Dispersione)',
    areaGroup: 'Area',
    histogramGroup: 'Istogramma',
    combinationGroup: 'Combinazioe',
    groupedColumnTooltip: 'Raggruppate',
    stackedColumnTooltip: 'Bloccate',
    normalizedColumnTooltip: '100% Bloccate',
    groupedBarTooltip: 'Raggruppate',
    stackedBarTooltip: 'Bloccate',
    normalizedBarTooltip: '100% Bloccate',
    pieTooltip: 'A torta',
    doughnutTooltip: 'A ciambella',
    lineTooltip: 'Linea',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Bloccata',
    normalizedAreaTooltip: '100% Bloccata',
    scatterTooltip: 'Dispesione',
    bubbleTooltip: 'A bolle',
    histogramTooltip: 'Istogramma',
    columnLineComboTooltip: 'Colonne e righe',
    areaColumnComboTooltip: 'Area e colonne',
    customComboTooltip: 'Combinazione personalizzata',
    noDataToChart: 'Nessun dato disponibile per essere tracciato.',
    pivotChartRequiresPivotMode: 'Grafico pivot richiede la modalità pivot abilitata.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Collega alla tabella',
    chartUnlinkToolbarTooltip: 'Scollega dalla tabella',
    chartDownloadToolbarTooltip: 'Scarica grafico',
    seriesChartType: 'Tipo di grafico della serie',
    seriesType: 'Tipo di serie',
    secondaryAxis: 'Asse secondario',

    // ARIA
    ariaChecked: 'selezionata',
    ariaColumn: 'Colonna',
    ariaColumnGroup: 'Gruppo colonna',
    ariaColumnList: 'Lista colonna',
    ariaColumnSelectAll: 'Toggle di selezione tutte le colonne',
    ariaDateFilterInput: 'Input filtro data',
    ariaDefaultListName: 'Lista',
    ariaFilterColumnsInput: 'Input filtro colonne',
    ariaFilterFromValue: 'Filtra dal valore',
    ariaFilterInput: 'Input filtro',
    ariaFilterList: 'Lista filtro',
    ariaFilterToValue: 'Filtra al valore',
    ariaFilterValue: 'Filtra valore',
    ariaFilteringOperator: 'Operatore del filtro',
    ariaHidden: 'nascosto',
    ariaIndeterminate: 'indeterminato',
    ariaInputEditor: 'Input Editor',
    ariaMenuColumn: 'Premi CTRL INVIO per aprire il menu della colonna.',
    ariaRowDeselect: 'Premi SPAZIO per deselezionare questa riga',
    ariaRowSelectAll: 'Premi SPAZIO per alternare la selezione di tutte le righe',
    ariaRowToggleSelection: 'Premi SPAZIO per alternare la selezione delle righe',
    ariaRowSelect: 'Premi SPAZIO per selezionare questa riga',
    ariaSearch: 'Cerca',
    ariaSortableColumn: 'Premi INVIO per ordinare',
    ariaToggleVisibility: 'Premi SPAZIO per alternare la visibilità',
    ariaUnchecked: 'deselezionato',
    ariaVisible: 'visibile',
    ariaSearchFilterValues: 'Cerca i valori del filtro',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Gruppi di righe',
    ariaValuesDropZonePanelLabel: 'Valori',
    ariaPivotDropZonePanelLabel: 'Etichette di colonna',
    ariaDropZoneColumnComponentDescription: 'Premi DELETE per rimuovere',
    ariaDropZoneColumnValueItemDescription: 'Premi INVIO per modificare il tipo di aggregazione',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Menu colonna',
    ariaLabelCellEditor: 'Editor cella',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Seleziona campo',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Menu contestuale',
    ariaLabelSubMenu: 'Sotto menu',
    ariaLabelAggregationFunction: 'Funzione di aggregazione',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',
    rowsPerPage: 'Righe per pagina:',

}
